module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('graveyard-select'), _vm._v(" "), _c('custom-table', {
    attrs: {
      "edit": "/deceaseds/{:id}",
      "add": "/deceaseds/new",
      "src-model": _vm.$store.getters.models('deceaseds'),
      "cols": _vm.cols,
      "criteria": _vm.criteria,
      "store": "deceaseds",
      "search": "",
      "default-sort": _vm.defSort
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Verstorbene")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a9aaa48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/DeceasedOverview.vue
// module id = 458
// module chunks = 0